module.exports = __webpack_public_path__ + "static/media/office-image.797dec1a.jpg";